import { DealTab } from '@app/app/components/applications/application-details/deal-tabs';

export class ActivateDealPageTabEvent {
  constructor(public tabName: DealTab) {}
}

export class LatestImportUpdatedEvent {
  constructor() {}
}
